import MantineGroup from "../mantine/group";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../mantine/menu";
import ArrowDown from "../../assets/svg/chevron-down";
import { useEffect, useState } from "react";
import { LocalGetUser } from "../../helpers/storagehelper";
import MantineButton from "../mantine/button";
import MantineText from "../mantine/text";
import { useStateContext } from "../../Contexts/ContextProvider";
import { IconSettings } from "@tabler/icons-react";
import MantineFlex from "../mantine/flex";
//import { useCurrentUrl } from "../../helpers/common";


const HeaderuserProfileIcon = (props: any) => {
    const { handleMenuPress, handleChangePassword, handleLogout, isSmallScreen } = props;
    const { setThemeSettings, currentPrimaryColor } = useStateContext();
    const [iconName, SetIconName] = useState<any>(null);
    const [iconRole, SetIconRole] = useState<any>(null);
    
    useEffect(() => {
        const user = LocalGetUser();
        if (user) {
            const firstName = user.firstName;
            const lastName = user.lastName;
            const role = user.userRoleName;
            SetIconName(`${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`);
            SetIconRole(role || '');
        }
    }, [LocalGetUser()])

    //const currentUrl =useCurrentUrl();
    
    return (
        <MantineFlex>
            <MantineMenu shadow="md" width={200} position='bottom-end'>
                <MantineMenuTarget>
                    <div>
                        <MantineGroup className='cursor-pointer'>
                            <MantineButton className="uppercase border-current-primary-color bg-current-secondary-color hover:bg-current-territory-color rounded-full text-white w-10 h-10 p-0 -mt-1" name={iconName} />
                            <MantineText name={iconRole} className={"-ml-2 text-sm"} />
                            <div className="-ml-3">
                                <ArrowDown
                                    width={"10"}
                                    height={"10"} />
                            </div>
                        </MantineGroup>
                    </div>
                </MantineMenuTarget>
                <MantineMenuDropdown >
                    {/* <MantineMenuItem onClick={handleMenuPress} className={`${currentUrl== '/profile' && 'bg-current-territory-color text-white'}`}>Your Profile</MantineMenuItem>
                    <MantineMenuItem onClick={handleChangePassword} className={`${currentUrl== '/changepassword' && 'bg-current-territory-color text-white'}`}>Change Password</MantineMenuItem> */}
                    <MantineMenuItem onClick={handleLogout}>Logout</MantineMenuItem>
                </MantineMenuDropdown>
            </MantineMenu>
            <div>
                <MantineButton variant="transparent" className={`${isSmallScreen && 'p-0'}`} rightSection={<IconSettings size={24} color={currentPrimaryColor} className="animate-spin duration-5000 linear infinite" />} onClick={() => setThemeSettings(true)} />
            </div>
        </MantineFlex>
    )
}
export default HeaderuserProfileIcon;